import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axois';

const DiningPaymentCallback = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const isVerifying = useRef(false);

    useEffect(() => {
        const verifyPayment = async () => {
            if (isVerifying.current) {
                return;
            }
            isVerifying.current = true;

            try {
                const urlParams = new URLSearchParams(window.location.search);
                const reference = urlParams.get('reference') || urlParams.get('trxref');

                if (!reference) {
                    setError('No payment reference found.');
                    setTimeout(() => navigate('/payment-failed'), 3000);
                    return;
                }

                const response = await api.get(`/kitchen/paystack/callback?reference=${reference}`);

                if (response.data.success) {
                    navigate('/dining/payment-success', { state: { order: response.data.order } });
                } else {
                    throw new Error(response.data.message || 'Payment verification failed');
                }
            } catch {
                setError('Payment verification failed. Please contact support.');
                setTimeout(() => navigate('/payment-failed'), 3000);
            } finally {
                isVerifying.current = false;
            }
        };

        verifyPayment();
    }, [navigate]);

    if (error) {
        return (
            <div className="payment-callback error">
                <h2>Payment Verification Failed</h2>
                <p>{error}</p>
                <p>Redirecting to error page...</p>
            </div>
        );
    }

    return (
        <div className="payment-callback">
            <h2>Verifying your payment...</h2>
            <p>Please wait while we confirm your order.</p>
        </div>
    );
};

export default DiningPaymentCallback;
